import { defineSlotRecipe } from '@chakra-ui/react'

export const formLayoutRecipe = defineSlotRecipe({
  className: 'form-layout',
  slots: ['root', 'section', 'fields', 'actions', 'title', 'description'],
  // Each slot is rendered by the component of the same name in
  // src/components/layout/FormLayout.tsx.
  base: {
    // <FormLayout.Root> — the form as a whole, its sections stacked.
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'page',
      width: 'full',
    },
    // <FormLayout.Section> — one group of related fields, with its own heading.
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'stack',
    },
    // <FormLayout.Fields> — a twelve-column grid of input fields.
    // Column spans stay a feature concern; they describe the form, not the layout.
    fields: {
      display: 'grid',
      gridTemplateColumns: { base: '1fr', md: 'repeat(12, minmax(0, 1fr))' },
      columnGap: 'fields',
      rowGap: 'fields',
    },
    // <FormLayout.Actions> — the buttons that submit or cancel.
    actions: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 'inline',
    },
    title: {
      textStyle: 'sectionTitle',
    },
    description: {
      textStyle: 'smNormal',
      color: 'fg.muted',
    },
  },
})
